import { useState } from 'react';
import type { CSSProperties, TextareaHTMLAttributes } from 'react';

export interface TextareaProps extends Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'onChange' | 'value' | 'style'> {
    value?: string;
    onChange?: (value: string) => void;
    invalid?: boolean;
    /** Estilo do invólucro, não do <textarea>. */
    style?: CSSProperties;
}

export function Textarea({
    value, onChange, placeholder, rows = 4, invalid = false, disabled = false, maxLength, id, style, ...rest
}: TextareaProps) {
    const [focus, setFocus] = useState(false);
    return (
        <div style={{ position: 'relative', ...style }}>
            <textarea
                id={id} rows={rows} value={value} placeholder={placeholder} disabled={disabled} maxLength={maxLength}
                aria-invalid={invalid || undefined}
                onChange={(e) => onChange?.(e.target.value)}
                onFocus={() => setFocus(true)}
                onBlur={() => setFocus(false)}
                style={{
                    width: '100%', resize: 'vertical', fontFamily: 'var(--font-ui)', fontSize: 15, lineHeight: '22px',
                    color: 'var(--text-primary)', background: disabled ? 'var(--surface-secondary)' : 'var(--surface)',
                    border: `1px solid ${invalid ? 'var(--danger)' : focus ? 'var(--border-focus)' : 'var(--border-strong)'}`,
                    borderRadius: 'var(--radius-input)', padding: '9px 12px', outline: 'none',
                    boxShadow: focus ? 'var(--focus-ring)' : 'none', transition: 'var(--transition-control)',
                }}
                {...rest}
            />
            {maxLength && (
                <span style={{ position: 'absolute', right: 10, bottom: 8, fontSize: 11, color: 'var(--text-tertiary)' }}>
                    {(value ?? '').length}/{maxLength}
                </span>
            )}
        </div>
    );
}
